import { render, staticRenderFns } from "./fileTree.vue?vue&type=template&id=dc3e3ff2&scoped=true"
import script from "./fileTree.vue?vue&type=script&lang=js"
export * from "./fileTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc3e3ff2",
  null
  
)

export default component.exports